import {CustomerId} from '@shared/services/api/user-entity';
import {GQLPagingParamsVariableStartIndexRequired, GRAPHQL_TYPES} from '@shared/services/api/http-utility-service';
import {MetadataType, MetadataTypeId} from '@app/graphql-typings/graphql';
import {FAULT_MODE_FIELDS, FaultMode, FaultModeId} from './fault-mode';
import {COMPONENT_FIELDS, TemplateComponent, TemplateComponentId} from './template-component';

export type TemplateCategoryId = number;

export interface TemplateCategoryCreateBody {
  metadata_type_id: MetadataTypeId;
  fault_mode_id: FaultModeId;
  component_id?: TemplateComponentId;
  shared: boolean;
}

export interface ReferenceData {
  faultModesById?: Map<FaultModeId, FaultMode>;
  componentsById?: Map<TemplateComponentId, TemplateComponent>;
  metadataTypesById?: Map<MetadataTypeId, MetadataType>;
}

export interface TemplateCategory extends TemplateCategoryCreateBody {
  template_category_id: TemplateCategoryId;
  metadataType?: MetadataType;
  fault_mode: FaultMode;
  component: TemplateComponent | null;
  customer_id: CustomerId;
}

export const TEMPLATE_CATEGORIES_OPERATION = 'template_categories';
export const TEMPLATE_CATEGORIES_GRAPHQL_QUERY = {
  operation: TEMPLATE_CATEGORIES_OPERATION,
  fields: [
    'template_category_id',
    'metadata_type_id',
    'fault_mode_id',
    {fault_mode: FAULT_MODE_FIELDS},
    'component_id',
    {component: COMPONENT_FIELDS},
    'customer_id',
    'shared'
  ],
  variables: {
    ...GQLPagingParamsVariableStartIndexRequired,
    template_category_id: {type: GRAPHQL_TYPES.INTEGER},
    template_category_ids: {type: GRAPHQL_TYPES.INTEGER, list: true},
    metadata_type_id: {type: GRAPHQL_TYPES.INTEGER},
    metadata_type_ids: {type: GRAPHQL_TYPES.INTEGER, list: true},
    fault_mode_id: {type: GRAPHQL_TYPES.INTEGER},
    fault_mode_ids: {type: GRAPHQL_TYPES.INTEGER, list: true},
    component_id: {type: GRAPHQL_TYPES.INTEGER},
    component_ids: {type: GRAPHQL_TYPES.INTEGER, list: true},
    customer_id: {type: GRAPHQL_TYPES.INTEGER},
    customer_ids: {type: GRAPHQL_TYPES.INTEGER, list: true},
    fault_component_metadata_type_tuples: {type: GRAPHQL_TYPES.INTEGER_ARRAY, list: true},
    shared: {type: GRAPHQL_TYPES.BOOLEAN}
  }
};

export interface TemplateCategorySearchTerm {
  template_category_id?: TemplateCategoryId;
  template_category_ids?: TemplateCategoryId[];
  metadata_type_id?: MetadataTypeId;
  metadata_type_ids?: MetadataTypeId[];
  fault_mode_id?: FaultModeId;
  fault_mode_ids?: FaultModeId[];
  component_id?: TemplateComponentId;
  component_ids?: TemplateComponentId[];
  customer_id?: CustomerId;
  customer_ids?: CustomerId[];
  fault_component_metadata_type_tuples?: [FaultModeId, TemplateComponentId, MetadataTypeId][];
  shared?: boolean;
}
